import { type ProcedureType } from "@overmap-ai/common"
import { selectProcedureTypeById } from "@overmap-ai/core"

import { appStore } from "../../store"
import { FilterModifier } from "./FilterModifier"

const deserializeProcedureTypeId = (filterValue: ProcedureType["uuid"]) => {
	const procedureType = selectProcedureTypeById(filterValue)(appStore.getState())

	return procedureType?.uuid
}

export const ProcedureTypeEqualsFilterModifier = FilterModifier.create<ProcedureType["uuid"], ProcedureType["uuid"]>({
	id: "procedure-type-equals",
	getApplyFn: (filterValue) => (value) => {
		return value === filterValue
	},
	render: () => "is",
	serialize: (filterValue) => filterValue,
	deserialize: deserializeProcedureTypeId,
})

export const ProcedureTypeNotEqualsFilterModifier = FilterModifier.create<ProcedureType["uuid"], ProcedureType["uuid"]>(
	{
		id: "procedure-type-not-equals",
		getApplyFn: (filterValue) => (value) => {
			return value !== filterValue
		},
		render: () => "is not",
		serialize: (filterValue) => filterValue,
		deserialize: deserializeProcedureTypeId,
	},
)

const deserializeProcedureTypeIds = (filterValue: ProcedureType["uuid"][]) => {
	const foundIds = filterValue.flatMap((procedureTypeId) => {
		const procedureType = selectProcedureTypeById(procedureTypeId)(appStore.getState())

		return procedureType ? [procedureType.uuid] : []
	})

	return foundIds.length > 0 ? foundIds : undefined
}

export const ProcedureTypeIncludesFilterModifier = FilterModifier.create<
	ProcedureType["uuid"],
	ProcedureType["uuid"][]
>({
	id: "procedure-type-includes",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			return filterValueSet.has(value)
		}
	},
	render: () => "is any of",
	serialize: (filterValue) => filterValue,
	deserialize: deserializeProcedureTypeIds,
})

export const ProcedureTypeExcludesFilterModifier = FilterModifier.create<
	ProcedureType["uuid"],
	ProcedureType["uuid"][]
>({
	id: "procedure-type-excludes",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			return !filterValueSet.has(value)
		}
	},
	render: () => "is none of",
	serialize: (filterValue) => filterValue,
	deserialize: deserializeProcedureTypeIds,
})
